export default "__VITE_ASSET__3I36rlmt__"